import {
    GET_HOLIDAY_LIST,
    LOADING_HOLIDAY,
    GET_LEAVE_TYPE_LIST,
    GET_APPLIED_LEAVE_LIST,
    GET_OWN_LEAVE_CALENDER,
    GET_OWN_LEAVE_REPORT_CART
} from '../constants';

const initialState = {
    holidayList: [],
    totalPage: 0,
    totalRecord: 0,
    leaveType: [],
    leaveList: [],
    calendarLeave: [],
    totalLeavePage: 0,
    totalLeaveRecord: 0,
    leaveReport: null,
    showLoading: false,
    screenVisible: false,
};

export function LeaveReducer(state = initialState, action) {
    if (action.type === GET_HOLIDAY_LIST) {
        return {
            ...state,
            totalPage: action.payload?.total_page ?? 0,
            totalRecord: action.payload?.total_record ?? 0,
            holidayList: action.payload?.data ?? [],
            screenVisible: true,
            showLoading: false,
        };
    }
    if (action.type === GET_LEAVE_TYPE_LIST) {
        return {
            ...state,
            leaveType: action.payload?.data ?? [],
        };
    }
    if (action.type === GET_APPLIED_LEAVE_LIST) {
        return {
            ...state,
            totalLeavePage: action.payload?.total_page ?? 0,
            totalLeaveRecord: action.payload?.total_record ?? 0,
            leaveList: action.payload?.data ?? [],
            screenVisible: true,
            showLoading: false,
        };
    }
    if (action.type === GET_OWN_LEAVE_CALENDER) {
        return {
            ...state,
            calendarLeave: action.payload?.data ?? [],
        };
    }
    if (action.type === GET_OWN_LEAVE_REPORT_CART) {
        return {
            ...state,
            leaveReport: action.payload ?? null,
        };
    }
    if (action.type === LOADING_HOLIDAY) {
        return {
            ...state,
            showLoading: action.payload,
        };
    }
    return state;
}


